module.exports = __webpack_public_path__ + "img/9.f08f58d9.png";